// import _ from 'lodash'

import MC from '@/module/MC'
import urlKeyMap from '@/module/utils/urlKeyMap'
import { drawBackground } from './utils'
import { signIn, getBusinessInfo, queryCenterStore, healthyLogin, loginMerchant, getUser, LoginOut, loginFanruan } from '@/module/apis/user'

export default {
  hdsecSignIn ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      loginMerchant(payload).then(async res => {
        console.log(res, '=====')
        const { token, userName } = res
        // 存储cookie所需标记
        await MC.setConfig({ userName, system: 'medical' })
        // 存储token
        await MC.setAuth(token)
        resolve({ ...res, ...{ system: { reEngSystem: 'medical', reSystem: '海典健康微商城' } } })
      }).catch(err => {
        console.log('0000', err)
        reject(err)
      })
    })
  },
  healthySignIn ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      healthyLogin(payload).then(async res => {
        const { token, userName, system: { reEngSystem }, fromChannel } = res
        // 存储是否erp来源
        MC.setCookie('isErp', fromChannel)

        // 存储cookie所需标记
        await MC.setConfig({ userName, system: reEngSystem })
        // 存储token
        await MC.setAuth(token)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  signIn ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      signIn(payload).then(async resLogin => {
        const { token, userName, system: { reEngSystem } } = resLogin
        // 存储cookie所需标记
        await MC.setConfig({ userName, system: reEngSystem })
        // 存储token
        await MC.setAuth(token)
        resolve(resLogin)
      }).catch(e => {
        reject(e)
      })
    })
  },
  getBusinessInfo ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      getBusinessInfo().then(async res => {
        const { resList, merCode, id, account } = res
        // handler url key value
        urlKeyMap(resList)

        commit('setReslist', resList)
        commit('setAccInfo', res)
        commit('setGlobalParams', { merCode })

        global.merCode = merCode
        global.userId = id
        global.name = account

        // 后端要求再次调用接口获取userName,满足他。鸡肋处理
        await getUser().then(res => {
          const mobile = res.mobile ? `${res.mobile.slice(7, _.size(res.mobile))}` : ''
          const userName = res.admin === 1
            ? '超级管理员'
            : res.userName
              ? res.userName
              : ''
          // 生成水印
          global.watermark = drawBackground(`${userName} ${mobile}`)
        })

        commit('setGlobalInfo', {
          merCode,
          userId: id,
          name: account
        })
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },
  logOut ({ commit }, payload) {
    LoginOut().then(_ => {
      setLoginOut()
    }).catch(_ => {
      setLoginOut()
    })
    function setLoginOut () {
      const hasMercode = sessionStorage.getItem('app-login:hasMercode')
      MC.cleanCookie()
      MC.delFrCookie()
      setTimeout(() => {
        if (hasMercode) {
          window.location.href = `/app-login?merCode=${hasMercode}`
          sessionStorage.clear(true)
        } else {
          sessionStorage.clear(true)
          setTimeout(() => {
            commit('setReset', '')
            window.location.href = `/app-login`
          }, 100)
        }
      }, 10)
    }
  },
  removeTagViewList ({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      resolve([])
    })
  },
  getCenterStoreId ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      queryCenterStore().then(res => {
        const { id, stName } = res.data
        commit('setCenterStore', { id, stName })
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },
  // 调用帆软的登录
  onLoginFanr ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      loginFanruan(payload).then(res => {
        resolve()
      }).catch(_ => {
        resolve()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/common/actions.js